import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { Col } from "react-bootstrap";
import './landingPage.scss';
import { get, post } from './../../utility/apiClient';
import queryString from 'query-string';

/*-- Import required components --*/
import { LandingPageViewEnum, responsiveScreenSizesEnum, LocalStorageEnum } from '../../utility/enums';
import MessageBox from '../../components/common/messageBox/MessageBox';
import LoadingScreen from '../../components/loadingScreen/LoadingScreen';
import WelcomeView from '../../components/welcomeView/WelcomeView';
import LoginView from '../../components/loginView/LoginView';
import RegistrationView from '../../components/registrationView/RegistrationView';
import PreferenceView from '../../components/preferenceView/PreferenceView';
import TrackYourOrder from '../../components/trackYourOrder/TrackYourOrder';
import ForgetPassword from '../../components/forgetPassword/ForgetPassword';
import storeResetFunction from '../../redux/storeResetFunction';
import PopupBox from '../../components/common/popupBox/PopupBox';
import NotificationHub from '../../components/notificationHub/NotificationHub';
import OutsideNotificationStripe from '../../components/notificationHub/OutsideNotificationStripe';
import InternalNavbar from '../../components/InternalNavbar/InternalNavbar';


/* --Imports for redux-- */
import { connect } from 'react-redux';
import { updateResponsive, resetResponsive } from '../../redux/actions/responsiveActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { addUserDetail } from '../../redux/actions/userDetailsActions';
import { addPreference } from '../../redux/actions/preferenceActions';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { updateOutsideNotificationStripe } from '../../redux/actions/notificationStripeActions';
import { updateQueueManagerToken } from '../../redux/actions/queueManagerActions';
import { updateIsShowGuestLoginFlag } from '../../redux/actions/welcomePageTilesAction';

/* Handle browser back */

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        loadingScreenVisible: state.loadingScreen,
        userData: state.userDetails,
        outsideNotificationStripe: state.outsideNotificationStripe,
        queueManagerToken: state.queueManager.token,
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    updateResponsive,
    resetResponsive,
    showLoadingScreen,
    hideLoadingScreen,
    addUserDetail,
    addPreference,
    showMessageBox,
    updateOutsideNotificationStripe,
    updateQueueManagerToken,
    updateIsShowGuestLoginFlag
};

class LandingPage extends Component {
    constructor(props) {
        super(props)
        this.responsive = this.responsive.bind(this);
        this.changeActiveView = this.changeActiveView.bind(this);

        this.state = {
            activeView: LandingPageViewEnum.WelcomeView
        }
    }

    changeActiveView(activeView) {
        window.location.href = `/welcome/${activeView}`;
    };

    componentDidMount() {
        this.checkExceptionLog();
        this.getOutsideNotificationStripe();

        if (this.props.match.params.active_view && this.props.match.params.active_view != '') {
            this.setState({ activeView: this.props.match.params.active_view }, () => {
                this.redirectToQueueManager();
            });
        }
        else {
            storeResetFunction();
            this.setState({ activeView: LandingPageViewEnum.WelcomeView }, () => {
                this.redirectToQueueManager();
            });
        }

        window.onpopstate = () => {
            switch (sessionStorage.getItem('activeView')) {
                case LandingPageViewEnum.LoginView: this.changeActiveView(LandingPageViewEnum.WelcomeView); break;
                case LandingPageViewEnum.RegistrationView: this.changeActiveView(LandingPageViewEnum.LoginView); break;
                default: this.changeActiveView(LandingPageViewEnum.WelcomeView); break;
            }
        }
        this.responsive();
        window.addEventListener('resize', this.responsive);


        // this.props.hideLoadingScreen();
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.responsive);
    };

    redirectToQueueManager() {
        const token = queryString.parse(window.location.search).token;
        if ((this.props.queueManagerToken === "") && (this.state.activeView === LandingPageViewEnum.WelcomeView || this.state.activeView === LandingPageViewEnum.LoginView)) {
            // const value = queryString.parse(window.location.search);
            // const token = queryString.parse(window.location.search).token;
            this.getQueueStatus(token);
        }
    }

    getQueueStatus(token) {
        this.props.showLoadingScreen();
        get(`/QueueManager/GetQueueStatus?token=${token}`).then(response => {
            if (response.data.statusCode === 200) {
                if (response.data.result != null) {
                    if (response.data.result.isRedirectToQueueManager) {
                        window.location.href = response.data.result.queueURL;
                    } else {
                        this.props.updateQueueManagerToken(token);
                    }
                } else {
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
            }
            else {
                let messageBox = {
                    show: true,
                    title: "Oops!",
                    className: "error",
                    content: response.data.errorList[0].statusMessage,
                    isConfirmation: false,
                    callBackFunction: null
                }
                this.props.showMessageBox(messageBox);
            }
            this.props.hideLoadingScreen();
        })
    }

    responsive() {
        if (window.innerWidth <= responsiveScreenSizesEnum.mobileSmallScreen) {
            let screen = { isTabScreen: false, isMobileLargeScreen: false, isMobileSmallScreen: true }
            this.props.updateResponsive(screen);
        } else if (window.innerWidth <= responsiveScreenSizesEnum.mobileLargeScreen) {
            let screen = { isTabScreen: false, isMobileLargeScreen: true, isMobileSmallScreen: false }
            this.props.updateResponsive(screen);
        } else if (window.innerWidth <= responsiveScreenSizesEnum.tabScreenSize) {
            let screen = { isTabScreen: true, isMobileLargeScreen: false, isMobileSmallScreen: false }
            this.props.updateResponsive(screen);
        } else {
            this.props.resetResponsive();
        }
    };

    guestLogin() {
        this.props.showLoadingScreen();
        post(`/Login/GuestLogin`).then(response => {
            if (response.data.statusCode === 200 && response.data.result.customerID > 0) {
                this.props.addUserDetail(response.data.result).then(() => {
                    let data = {
                        outletCode: response.data.result.preferredOutlet,
                        outletName: response.data.result.preferredOutletDescription,
                        shoppingMethod: "Delivery",
                        suburbID: 0
                    }
                    this.props.addPreference(data).then(() => {
                        this.props.hideLoadingScreen();
                        window.location.href = "/";
                    })
                })
            } else {
                let messageBox = {
                    show: true,
                    title: "Oops!",
                    className: "error",
                    content: response.data.errorList[0].statusMessage,
                    isConfirmation: false,
                    callBackFunction: null
                }
                this.props.showMessageBox(messageBox);
            }
            this.props.hideLoadingScreen();
        })
    }

    getOutsideNotificationStripe() {
        //prevent always calling the endpoint
        if (!this.props.outsideNotificationStripe.triggered) {
            this.props.showLoadingScreen();
            get(`/Notification/GetOutsideNotificationStripe`).then(response => {
                if (response.data.statusCode === 200) {
                    if (response.data.result) {
                        let body = {
                            message: response.data.result.message,
                            cssClass: response.data.result.cssClass,
                            isActive: response.data.result.message ? true : false,
                            triggered: true
                        }
                        this.props.updateOutsideNotificationStripe(body);
                        this.props.updateIsShowGuestLoginFlag(response.data.result.welcomeSystemConfiguration.showGuestLogin);
                    }
                }
                else {
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    }

    checkExceptionLog() {
        let customerID = localStorage.getItem(LocalStorageEnum.ErrorCustomerID);
        let errorObject = localStorage.getItem(LocalStorageEnum.ErrorObject);
        let errorTimeStamp = localStorage.getItem(LocalStorageEnum.ErrorTimeStamp);
        if (customerID && errorObject && errorTimeStamp) {
            this.props.showLoadingScreen();
            //log error in db
            let postBody = {
                CustomerID: parseInt(customerID),
                ErrorObject: errorObject,
                TimeStamp: errorTimeStamp
            }

            post(`/Web/LogClientException`, postBody).then(response => {
                if (response.data.statusCode === 200) {
                    if (response.data.result) {
                        localStorage.removeItem(LocalStorageEnum.ErrorCustomerID);
                        localStorage.removeItem(LocalStorageEnum.ErrorObject);
                        localStorage.removeItem(LocalStorageEnum.ErrorTimeStamp);
                    }
                }
                this.props.hideLoadingScreen();
            })
        }
    }

    render() {
        return (
            <div>
                {/* <div className={this.props.outsideNotificationStripe.isActive ? "notification-holder-stripe" : ""} /> */}
                <OutsideNotificationStripe />
                {
                    this.state.activeView === LandingPageViewEnum.PreferenceView ?
                        <InternalNavbar />
                        : null
                }
                {
                    this.state.activeView === LandingPageViewEnum.PreferenceView ? null :
                        <div className={`${this.state.activeView === LandingPageViewEnum.WelcomeView ? 'landing-page-area' : 'login-registration-page-area'}`} />

                }
                <div className={this.state.activeView === LandingPageViewEnum.PreferenceView ? 'col' : 'justify-content-center d-flex align-items-center col'} style={{ minHeight: this.state.activeView === LandingPageViewEnum.PreferenceView ? '100%' : '100vh' }}>
                    <WelcomeView isVisible={this.state.activeView === LandingPageViewEnum.WelcomeView} changeActiveView={this.changeActiveView} guestLogin={this.guestLogin.bind(this)} />
                    <LoginView isVisible={this.state.activeView === LandingPageViewEnum.LoginView}
                        onRegisterClick={this.changeActiveView.bind(this, LandingPageViewEnum.RegistrationView)}
                        onLogin={this.changeActiveView.bind(this, LandingPageViewEnum.PreferenceView)}
                        onForgetPassword={this.changeActiveView.bind(this, LandingPageViewEnum.ForgetPasswordView)}
                        guestLogin={this.guestLogin.bind(this)} />
                    <RegistrationView isVisible={this.state.activeView === LandingPageViewEnum.RegistrationView} />
                    <TrackYourOrder isVisible={this.state.activeView === LandingPageViewEnum.TrackOrderView} orderNumber={this.props.match.params.orderNumber} />
                    {this.state.activeView === LandingPageViewEnum.PreferenceView ? <PreferenceView isVisible={this.state.activeView === LandingPageViewEnum.PreferenceView} /> : null}
                    <ForgetPassword isVisible={this.state.activeView === LandingPageViewEnum.ForgetPasswordView} />
                </div>
                <MessageBox />
                <NotificationHub />
                <PopupBox />
                <LoadingScreen isVisible={this.props.loadingScreenVisible} />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
